export const TITLE_HEADING_H1 = 'h1';
export const TITLE_HEADING_H2 = 'h2';
export const TITLE_HEADING_H3 = 'h3';
export const TITLE_HEADING_DIV = 'div';
